import { skipToken, useMutation, useQuery } from "@tanstack/react-query"

import type { IUserIdParams } from "@commonTypes/user"
import { OFFER_TYPES } from "@apis/offers/types"
import { accountKeys } from "@apis/accounts/queryKeys"

import { acceptRetentionOffer, getRetentionOffers } from "./retention"

export const useGetRetentionOffersQuery = (
  account_id: string,
  params: IUserIdParams,
  isEnabled: boolean = true,
) => {
  return useQuery({
    queryKey: accountKeys.retentionOffersForAccount(account_id, params),
    queryFn: isEnabled
      ? () => getRetentionOffers(account_id, params)
      : skipToken,
    select: (response) => ({
      ...response.data,
      // Stamp the provenance so the offer funnel can tell retention offers apart
      // from winback ones without inspecting their shape (see NEE-4061).
      eligible_offers: (response.data.eligible_offers ?? []).map((offer) => ({
        ...offer,
        offerSource: OFFER_TYPES.Retention,
      })),
      requestId: response.headers["x-request-id"]?.split("-")[0] ?? "",
    }),
  })
}

export const useAcceptRetentionOfferMutation = () => {
  return useMutation({
    mutationFn: acceptRetentionOffer,
  })
}
